import React,{useEffect} from 'react';
import {Image} from "semantic-ui-react";
import { map } from 'lodash';
import {Link} from "react-router-dom";
import { useQuery } from '@apollo/client';
import {GET_COMENTS} from "../../../gql/comment";
import icona from "../../../asets/png/icona.jpg";
import "./Comments.scss";




function Comments(props) {
    const {publication } = props

    const {data,loading, startPolling, stopPolling} = useQuery(GET_COMENTS,{
        variables: {
            idPublication:  publication.id  || publication._id || publication,
        }
    });

    useEffect(() => {
      startPolling (2000);
    
      return () => {
        stopPolling();
      };
    }, [startPolling, stopPolling]);
    





    if (loading) return null;
    const {getComments} = data;
     

    




  return (
    <div className='coments' >
       {map(getComments, (comment,index) => (
        <Link key ={index}to ={`/${comment.idUser.username}`}
        className= "commenta">
            <Image src = {comment.idUser.avatar || icona} avatar />
            <div>
                <p> {comment.idUser.username}</p>
                <p> {comment.comment}</p>
            </div>
        </Link>
       ))}
    </div>
  )
}

export default Comments